import {
  ArrowUpFromLine, BatteryFull, Bell, BellRing, Car, ChevronsDown, Chrome,
  Compass, Download, KeyRound, MoreVertical, Settings, SquarePlus, Zap,
} from "lucide-react";
import "./install-scenes.css";

const GOLD = "#D4A017";

// iter72 corte 3 v2 — ÍCONOS GRANDES Y RECONOCIBLES por paso.
// Prohibido: mockups de navegador falso. Un ícono claro por acción.

export const IosShareGlyph = ({ className, strokeWidth = 2 }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3v12" /><path d="M8 7l4-4 4 4" /><path d="M5 11v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8" />
  </svg>
);

const LockGlyph = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

const BrandIcon = ({ className, ...rest }) => (
  <span className={`inline-flex items-center justify-center rounded-2xl ${className}`} style={{ backgroundColor: "#1B84FF" }} {...rest}>
    <Car className="w-3/5 h-3/5 text-white" />
  </span>
);

// tone: gold (acción sobre control) · brand (ícono AvisoCar) · slate (neutro)
const ICONS = {
  ios: [
    { Icon: Compass, tone: "sky" },            // 1 Safari
    { Icon: IosShareGlyph, tone: "gold" },     // 2 Compartir
    { Icon: ChevronsDown, tone: "slate" },     // 3 desliza
    { Icon: SquarePlus, tone: "gold" },        // 4 añadir a inicio
    { Icon: SquarePlus, tone: "gold", badge: "+" }, // 5 Añadir
    { Icon: ArrowUpFromLine, tone: "slate" },  // 6 cierra Safari
    { brand: true },                            // 7 ícono nuevo
    { Icon: KeyRound, tone: "slate" },         // 8 login
    { Icon: Settings, tone: "slate" },         // 9 Configuración
    { Icon: Bell, tone: "gold" },              // 10 activar push
    { Icon: BellRing, tone: "gold" },          // 11 Permitir
    { Icon: Zap, tone: "brandline" },          // 12 probar
  ],
  android: [
    { Icon: Chrome, tone: "sky" },             // 1 Chrome
    { Icon: MoreVertical, tone: "gold" },      // 2 menú ⋮
    { Icon: Download, tone: "gold" },          // 3 instalar aplicación
    { Icon: Download, tone: "gold" },          // 4 confirmar
    { brand: true },                            // 5 ícono nuevo
    { Icon: KeyRound, tone: "slate" },         // 6 login
    { Icon: Settings, tone: "slate" },         // 7 Configuración
    { Icon: Bell, tone: "gold" },              // 8 activar push
    { Icon: LockGlyph, tone: "gold" },         // 9 Permitir / candado
    { Icon: Zap, tone: "brandline" },          // 10 probar
    { Icon: BatteryFull, tone: "slate" },      // 11 batería
  ],
};

const TONES = {
  gold: { bg: `${GOLD}1f`, border: `${GOLD}66`, color: GOLD },
  sky: { bg: "#0ea5e91a", border: "#0ea5e955", color: "#0284c7" },
  slate: { bg: "#f1f5f9", border: "#e2e8f0", color: "#475569" },
  brandline: { bg: "#1B84FF1a", border: "#1B84FF55", color: "#0F6FDB" },
};

export const StepBigIcon = ({ os, index }) => {
  const spec = ICONS[os]?.[index];
  if (!spec) return null;
  if (spec.brand) {
    return <BrandIcon className="w-20 h-20 shadow-lg" data-testid={`step-icon-${os}-${index + 1}`} />;
  }
  const tone = TONES[spec.tone] || TONES.slate;
  const { Icon } = spec;
  return (
    <span
      className="inline-flex items-center justify-center w-20 h-20 rounded-2xl border-2 shrink-0"
      style={{ backgroundColor: tone.bg, borderColor: tone.border, color: tone.color }}
      data-testid={`step-icon-${os}-${index + 1}`}
    >
      <Icon className="w-10 h-10" />
    </span>
  );
};
